import styled from 'styled-components'

import Input, { InputComponentProps } from './Input'

const TextArea = styled(Input)<InputComponentProps>`
  resize: none;
`

export default TextArea
